<template>
  <div class="admin-wrapper">
    <Header />
    <div class="admin-dashboard">
      <div class="admin-header">
        <h1 class="title">Painel de Administração</h1>
        <p>Gerencie seus parceiros institucionais, vendas de licenças e finanças.</p>
      </div>

    <div class="admin-grid">
      <router-link to="/admin/users" class="admin-card">
        <div class="card-icon"><i class="fa-solid fa-user-shield"></i></div>
        <h3>Gestão de Usuários</h3>
        <p>Gerencie, edite, atualize e crie usuários do sistema.</p>
      </router-link>

      <router-link to="/admin/partners" class="admin-card">
        <div class="card-icon"><i class="fa-solid fa-users"></i></div>
        <h3>Gestão de Parceiros</h3>
        <p>Gerencie instituições, ative/cancele acessos e acompanhe materiais.</p>
      </router-link>

      <router-link to="/admin/financial" class="admin-card">
        <div class="card-icon"><i class="fa-solid fa-chart-line"></i></div>
        <h3>Dashboard Financeiro</h3>
        <p>Relatórios, gráficos mensais, status de pagamento e faturamento (Pagar.me).</p>
      </router-link>

      <router-link to="/admin/pricing" class="admin-card">
        <div class="card-icon"><i class="fa-solid fa-tags"></i></div>
        <h3>Tabela de Preços</h3>
        <p>Defina o valor base dos pacotes, livros, vídeos e simulados individuais.</p>
      </router-link>

      <router-link to="/admin/simulator" class="admin-card">
        <div class="card-icon"><i class="fa-solid fa-calculator"></i></div>
        <h3>Simulador de Vendas</h3>
        <p>Calcule simulações de vendas de acordo com pacotes e volume de alunos.</p>
      </router-link>
    </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'AdminDashboard',
  components: { Header },
  mounted() {
      // Aqui podemos carregar resumos globais futuramente
  }
}
</script>

<style scoped>
.admin-wrapper {
  background-image: linear-gradient(to bottom, #09105D, #1322C1);
  min-height: 100vh;
  padding-top: 100px;
}

.admin-dashboard {
  padding: 20px 40px 40px;
  max-width: 1200px;
  margin: 0 auto;
  color: #fff;
}

.admin-header {
  margin-bottom: 40px;
  text-align: center;
}

.admin-header .title {
  color: #FEC401;
  font-size: 2.5rem;
  margin-bottom: 10px;
}

.admin-header p {
  font-size: 1.1rem;
  opacity: 0.9;
}

.admin-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.admin-card {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: 30px 20px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.admin-card:hover {
  background: #09105D;
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(9, 16, 93, 0.3);
  border-color: #FEC401;
}

.admin-card:hover h3 {
  color: #FEC401;
}

.card-icon {
  font-size: 40px;
  color: #FEC401;
  margin-bottom: 20px;
}

.admin-card h3 {
  font-size: 1.3rem;
  margin-bottom: 10px;
  font-weight: 600;
  transition: color 0.3s;
}

.admin-card p {
  font-size: 0.95rem;
  opacity: 0.8;
  line-height: 1.5;
}
</style>
